import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {User} from '../user/user';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {MatOption, MatSelect} from '@angular/material/select';
import {UserService} from "../user/user.service";
import {KeyValuePipe} from "@angular/common";

@Component({
  selector: 'app-edit-profile',
  imports: [
    FormsModule,
    MatButton,
    MatDialogContent,
    MatDialogTitle,
    MatFormField,
    MatIcon,
    MatIconButton,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    TranslatePipe,
    MatSelect,
    MatOption,
    KeyValuePipe
  ],
  templateUrl: './edit-profile.component.html',
  styleUrl: './edit-profile.component.scss'
})
export class EditProfileComponent implements OnInit {
  userForm: FormGroup;
  countries: any;
  constructor(public ref: MatDialogRef<EditProfileComponent>,
              @Inject(MAT_DIALOG_DATA) public user: User,
              private fb: FormBuilder,
              private userService: UserService,
              private translate: TranslateService) {
    this.userForm = this.fb.group({
      email: ['', Validators.required],
      firstName: ['', ],
      lastName: ['', Validators.required],
      company: ['', []],
      department: ['', []],
      jobTitle: ['', []],
      country: ['', []],
    })
   // this.countries = ['AT', 'AU', 'BE', 'CA', 'CH', 'DE', 'ES', 'FR', 'GB', 'IT', 'JP', 'NO', 'PL', 'SE', 'US']
  }
  ngOnInit() {
    this.userForm.patchValue(this.user);
    this.userService.getUserCountries(this.translate.defaultLang).subscribe( res => {
     this.countries = res.data;
    })
  }
  close() {
    this.ref.close();
  }
  save() {
    this.ref.close(this.userForm.value);
  }

}
